import { useRef } from 'react';
import { useToggle } from '@/hooks/useToggle';
import { OptionsIcon } from '@/icons';
import DefaultOptionsMenu from '@/components/DefaultOptionsMenu';
import { classes } from './utils';

export type OptionsMenuProps = {
  onEdit: () => void;
  onDelete: () => void;
};

export default function OptionsMenu({ onEdit, onDelete }: OptionsMenuProps) {
  const menuToggleRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle();

  return (
    <div className={classes.optionsWrapper}>
      <OptionsIcon
        ref={menuToggleRef}
        className={classes.optionsIcon}
        onClick={() => toggleMenu()}
      />
      <DefaultOptionsMenu
        anchorTo={menuToggleRef.current}
        open={isMenuOpen}
        onEdit={onEdit}
        onDelete={onDelete}
        onClose={() => toggleMenu()}
      />
    </div>
  );
}
